/** Material categories that use pipe traceability (NRI, pipe no., heat, etc.) on the server. */

export const PIPE_LIKE_MATERIAL_CATEGORIES = [

  'Pipe',

  'Bends',

  'Flanges',

  'Reducer',

  'T-Piece',

  'Weldolet',

  'End Cap',

  'Sweepolet',

  'Hydro',

  'Torquing',

  'Gauging',

  'Flushing',

] as const;



export type PipeLikeMaterialCategory = (typeof PIPE_LIKE_MATERIAL_CATEGORIES)[number];



export const isPipeLikeMaterialCategory = (

  category: string | undefined | null

): category is PipeLikeMaterialCategory =>

  category != null && (PIPE_LIKE_MATERIAL_CATEGORIES as readonly string[]).includes(category);



/** Spool fittings that capture two diameters (Diameter 1 / Diameter 2) instead of a single outer diameter. */

export const DUAL_DIAMETER_MATERIAL_CATEGORIES = [

  'Reducer',

  'T-Piece',

  'Weldolet',

  'Sweepolet',

] as const;



export type DualDiameterMaterialCategory = (typeof DUAL_DIAMETER_MATERIAL_CATEGORIES)[number];



export const isDualDiameterMaterialCategory = (

  category: string | undefined | null

): category is DualDiameterMaterialCategory =>

  category != null && (DUAL_DIAMETER_MATERIAL_CATEGORIES as readonly string[]).includes(category);



/** Fabrication sub-types that show Base Pipes, Bends, Flanges, spool fittings, Hydro, Torquing, Gauging, Flushing, etc. */

export const isBendsFlangesLayoutFabricSubType = (subType: string | undefined): boolean => {

  if (subType == null || subType === '') return false;

  const s = subType.toLowerCase();

  return s === 'bulkhead' || s === 'spools' || s === 'spool';

};



/** Buckle Arrestor gets Pipe/Forge/etc. plus Flanges (not the full bends/spools tab set). */

export const isBuckleArrestorFabricSubType = (subType: string | undefined): boolean =>

  (subType ?? '').toLowerCase() === 'bucklearrestor';



/** Tabs shown for spools / bulkhead fabrication material traceability. */

export const FABRIC_BENDS_FLANGES_MATERIAL_TAB_KEYS = [

  'pipe',

  'Bends',

  'Flanges',

  'Reducer',

  'T-Piece',

  'Weldolet',

  'End Cap',

  'Sweepolet',

  'hydro',

  'torquing',

  'gauging',

  'flushing',

  'gas',

  'wire',

  'coating',

  'misc',

] as const;



export type FabricBendsFlangesMaterialTabKey = (typeof FABRIC_BENDS_FLANGES_MATERIAL_TAB_KEYS)[number];



/** API grouped response key for each pipe-like category. */

export const PIPE_LIKE_CATEGORY_SETUP_DATA_KEY: Record<PipeLikeMaterialCategory, string> = {

  Pipe: 'pipes',

  Bends: 'bends',

  Flanges: 'flanges',

  Reducer: 'reducers',

  'T-Piece': 'tPiece',

  Weldolet: 'weldolet',

  'End Cap': 'endCap',

  Sweepolet: 'sweepolet',

  Hydro: 'hydro',

  Torquing: 'torquing',

  Gauging: 'gauging',

  Flushing: 'flushing',

};



/** Spool-fitting tabs (Reducer, T-Piece, etc.) for materials dashboard configuration. */

export const SPOOL_FITTING_MATERIAL_TAB_CONFIG = [

  { tabKey: 'Reducer', category: 'Reducer', dataKey: 'reducers', label: 'Reducer', description: 'reducer items' },

  { tabKey: 'T-Piece', category: 'T-Piece', dataKey: 'tPiece', label: 'T-Piece', description: 't-piece items' },

  { tabKey: 'Weldolet', category: 'Weldolet', dataKey: 'weldolet', label: 'Weldolet', description: 'weldolet items' },

  { tabKey: 'End Cap', category: 'End Cap', dataKey: 'endCap', label: 'End Cap', description: 'end cap items' },

  { tabKey: 'Sweepolet', category: 'Sweepolet', dataKey: 'sweepolet', label: 'Sweepolet', description: 'sweepolet items' },

] as const;


